/* eslint-disable react/prop-types */
import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router';
import { helperGetBioUrl } from 'helpers/RouteHelper';
import classNames from 'classnames';
import Icon from 'components/Icon';
import { LINK_REL } from 'helpers/ContentHelper';
import { toBoolean } from 'helpers/GlobalHelper';
import {
  SHOW_DETAIL_CAST_THUMBNAIL_LIST_IMAGE,
  SHOW_DETAIL_CAST_DETAIL_IMAGE,
  renderImage as renderDynamicImage,
} from 'helpers/ImageHelper';
import { SITE_PLATFORM_TABLET } from 'helpers/BreakpointHelper';

export const TYPE_CREDIT = 'Credit';
const ICON_FACEBOOK = 'facebook';
const ICON_TWITTER = 'twitter';

export const getCreditMemberId = ({ member }) => _.get(member, 'id');

export const getCreditMemberSlug = ({ member }) => _.get(member, 'alternateId');

export const getCreditMemberUrl = ({ showId, member }) => {
  const slug = member ? getCreditMemberSlug({ member }) : null;
  const url = showId && slug ? helperGetBioUrl(showId, slug) : null;
  return url;
};

const renderSocialNetworkItem = ({ style, data, idx }) => {
  if (!data) return null;
  const listClassName = classNames([style.socialNetworkItem, style[data.icon]]);

  return (
    <li key={idx} className={listClassName}>
      <Link to={data.url} target="_blank" rel={LINK_REL} title={data.icon}>
        <Icon color="white" icon={data.icon} />
      </Link>
    </li>
  );
};

export const renderSocialNetworks = ({ style, data }) => {
  const socialNetworks = [];

  const facebookId = _.get(data, 'facebookId');
  let facebookUrl = _.get(data, 'facebookUrl');
  if (facebookId) facebookUrl = `https://www.facebook.com/${facebookId}/`;
  if (facebookUrl) {
    socialNetworks.push({ icon: ICON_FACEBOOK, url: facebookUrl });
  }

  const twitterId = _.get(data, 'twitterId');
  let twitterUrl = _.get(data, 'twitterUrl');
  if (twitterId) twitterUrl = `https://twitter.com/${twitterId}`;
  if (twitterUrl) {
    socialNetworks.push({ icon: ICON_TWITTER, url: twitterUrl });
  }

  if (socialNetworks.length === 0) return null;

  return (
    <div className={style.socialNetworks}>
      <ul className={style.socialNetworksList}>
        {socialNetworks.map((item, idx) => renderSocialNetworkItem({ style, data: item, idx }))}
      </ul>
    </div>
  );
};

export const getGroupedCast = cast => {
  const filteredCast = cast.filter(item => hasFullBio(item));
  const groupedCast = _.groupBy(filteredCast, 'category');
  return groupedCast;
};

export const renderRole = ({ style, data }) => {
  const role = _.get(data, 'role');
  if (!role) return null;

  return <div className={style.role}>{role}</div>;
};

export const renderName = ({ style, data, isDetail }) => {
  const name = getName(data);
  if (!name) return null;

  return <div className={style.name}>{isDetail ? <h1>{name}</h1> : name}</div>;
};

export const renderImage = ({ style, data, isDetail, breakpoint }) => {
  const isTabletView = breakpoint === SITE_PLATFORM_TABLET;
  const imageUrl = isDetail || isTabletView ? getDetailImage(data) : getListingImage(data);
  const name = getName(data);
  const imageTag = renderDynamicImage({
    alt: name,
    breakpoint,
    imageType:
      isDetail || isTabletView
        ? SHOW_DETAIL_CAST_DETAIL_IMAGE
        : SHOW_DETAIL_CAST_THUMBNAIL_LIST_IMAGE,
    src: imageUrl,
  });

  if (!imageUrl) return null;

  return <div className={style.image}>{imageTag}</div>;
};

export const getName = member => {
  const name = _.get(member, 'name');
  return name;
};

const getFallbackImage = member => {
  const sample = _.get(member, 'images.sampleImage');
  const fallback = _.get(member, 'images.undefined', sample);
  return fallback;
};

export const getDetailImage = member => {
  const fallback = getFallbackImage(member);
  const imageUrl = _.get(member, 'images.bioDetail', fallback);
  return imageUrl;
};

export const getListingImage = member => {
  const fallback = getFallbackImage(member);
  const imageUrl = _.get(member, 'images.bioListing', fallback);
  return imageUrl;
};

export const getBioDescription = member => {
  const longBio = _.get(member, 'longBio');
  return longBio;
};

export const hasFullBio = member => {
  const hasName = toBoolean(getName(member));
  const hasBioDescription = toBoolean(getBioDescription(member));
  return hasName && hasBioDescription;
};
